import { Landscape } from '../../models/landscape';
import { WorldRegion } from '../../models/world-region';

export class RegionAndLandscapeState {
  regions: WorldRegion[] = [];
  landscapes: Landscape[] = [];

  constructor() {}
}
